import { AfterViewInit, Inject, Input, Renderer2 } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { RedsysService } from '../shared/services/redsys/redsys.service';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redsys',
  templateUrl: './redsys.component.html',
  styleUrls: ['./redsys.component.scss']
})
export class RedsysComponent implements OnInit, AfterViewInit {

  @Input() dsMerchantParameters: any;
  @Input() dsSignature: any;
  urlPasarela = environment.redsys.urlPasarela;
  respuestaRedsys = false;
  htmlRespuestaRedsys: any;
  @ViewChild('ventanaRedsys') ventanaRedsys: ElementRef;

  redsysGroup = new FormGroup({
    dsMerchantParameters: new FormControl(),
    dsSignature: new FormControl(),
    dsSignatureVersion: new FormControl(environment.redsys.dsSignatureVersion)
  });

  constructor(
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public http: HttpClient,
    public redsysService: RedsysService
  ) { }
  ngAfterViewInit(): void {
    const d1 = document.querySelector('.boton-redsys');

    const html = this._renderer2.createElement('form');
    const inputSignatureVersion = this._renderer2.createElement('input');
    this._renderer2.setAttribute(inputSignatureVersion, 'type', 'hidden');
    this._renderer2.setAttribute(inputSignatureVersion, 'name', 'Ds_SignatureVersion');
    this._renderer2.setAttribute(inputSignatureVersion, 'value', 'HMAC_SHA256_V1');
    const inputMerchantParameters = this._renderer2.createElement('input');
    this._renderer2.setAttribute(inputMerchantParameters, 'type', 'hidden');
    this._renderer2.setAttribute(inputMerchantParameters, 'name', 'Ds_MerchantParameters');
    this._renderer2.setAttribute(inputMerchantParameters, 'value', this.dsMerchantParameters);
    const inputSignature = this._renderer2.createElement('input');
    this._renderer2.setAttribute(inputSignature, 'type', 'hidden');
    this._renderer2.setAttribute(inputSignature, 'name', 'Ds_Signature');
    this._renderer2.setAttribute(inputSignature, 'value', this.dsSignature);
    const inputboton = this._renderer2.createElement('button');
    this._renderer2.setAttribute(inputboton, 'type', 'submit');
    const textBotton = this._renderer2.createText('Pagar')
    this._renderer2.appendChild(inputboton, textBotton);
    this._renderer2.setAttribute(inputboton, 'class', 'btn btn-secondary btn-lg');
  // this._renderer2.setAttribute(inputboton, 'value', 'Pago');
    //this._renderer2.setAttribute(html, 'src', this.urlPasarela);
    this._renderer2.setAttribute(html, 'action', this.urlPasarela);
    this._renderer2.setAttribute(html, 'method', 'POST');
    this._renderer2.setAttribute(html, 'target', '_self');
    //this._renderer2.setAttribute(html, 'id', 'form-redsys-botton');
    this._renderer2.appendChild(html, inputSignatureVersion);
    this._renderer2.appendChild(html, inputMerchantParameters);
    this._renderer2.appendChild(html, inputSignature);
    this._renderer2.appendChild(html, inputboton);
    d1.appendChild(html);
    // this._renderer2.appendChild(d1, html);
  }

  ngOnInit() {
    
    this.dsMerchantParameters = this.dsMerchantParameters.replace(/\s{2,}/g, ' ').trim();
    this.dsSignature = this.dsSignature.replace(/\s{2,}/g, ' ').trim();
    this.redsysGroup.get('dsMerchantParameters').setValue(this.dsMerchantParameters);
    this.redsysGroup.get('dsSignature').setValue(this.dsSignature);
  }


  merchantValidation() {
    return true;
  }

  async onSubmit() {
    const result = await this.redsysService.generatePayGold(this.redsysGroup.value);
    if (result && result[`success`]) {
      const html = this._renderer2.createElement('iframe');
      const inputSignatureVersion = this._renderer2.createElement('input');
      this._renderer2.setAttribute(html, 'type', 'hidden');
      this._renderer2.setAttribute(html, 'name', 'Ds_SignatureVersion');
      this._renderer2.setAttribute(html, 'value', 'HMAC_SHA256_V1');
      const inputMerchantParameters = this._renderer2.createElement('input');
      this._renderer2.setAttribute(html, 'type', 'hidden');
      this._renderer2.setAttribute(html, 'name', 'Ds_MerchantParameters');
      this._renderer2.setAttribute(html, 'value', this.dsMerchantParameters);
      const inputSignature = this._renderer2.createElement('input');
      this._renderer2.setAttribute(html, 'type', 'hidden');
      this._renderer2.setAttribute(html, 'name', 'Ds_Signature');
      this._renderer2.setAttribute(html, 'value', this.dsSignature);
      this._renderer2.setAttribute(html, 'src', this.urlPasarela);
      this._renderer2.setAttribute(html, 'action', this.urlPasarela);
      this._renderer2.setAttribute(html, 'method', 'POST');
      this._renderer2.setAttribute(html, 'target', '_self');
      this._renderer2.appendChild(html, inputSignatureVersion);
      this._renderer2.appendChild(html, inputMerchantParameters);
      this._renderer2.appendChild(html, inputSignature);

      document.getElementById('ventanaRedsys').appendChild(html);
      //this._renderer2.appendChild(this.ventanaRedsys,html);
      console.log(result[`success`]);
    }
  }
}
